document.addEventListener('click', function (e) {
    const element = e.target.closest(`#btn-print`);
    if (element)
        window.print();
});
